import { trimFilters } from '~/services/api/api-utils';

class _MissionMediasAPI {
  constructor() {
    // this.API = API;
    this.includesMedias = [
      'files',
      'status',
      'metas',
    ];
    this.perPage = 'all';
    this.versionPrefix = '/v2';
    this.url = `${this.versionPrefix}/mission-media/`;
    this.missionUrl = `${this.versionPrefix}/missions/`;
  }

  /**
   * Initialize.
   * TEMPORARY:
   *    The whole axios / auth should be replaced by proper install & usage.
   * @param {object} $axios - @nuxtjs/axios instance
   */
  init($axios) {
    this.API = $axios;
  }

  /**
   * Fetch Mission Medias
   * @param {string} missionId - The mission ID
   * @return {array} - Array of mission medias data
   */
  async fetchMissionMedias(missionId, meta = {}, filters = null) {
    const perPage = meta && meta.perPage ? meta.perPage : this.perPage;
    const currentPage = meta && meta.current_page ? meta.current_page : 1;
    const nonEmptyFilters = filters ? trimFilters(filters) : filters;
    const requestURI = `${this.missionUrl}${missionId}/media`;
    try {
        const { status, data } = await this.API.get(requestURI, {
          params: {
            p: 'thumb',
            include: this.includesMedias.join(','),
            withFilename: 1,
            per_page: perPage,
            current_page: currentPage,
            ...nonEmptyFilters,
          },
        });
        return Promise.resolve({ status, data: data.data, meta: data.meta });
    } catch ({ response, code }) {
        const res = {
          data: response ? response.data : null,
          status: response ? response.status : null,
        };
        if (code === 'ECONNABORTED') {
          res.data = { message: 'Timeout Error on media loading' };
          res.status = 408;
        }
        return Promise.reject(res);
    }
  }

  /**
   * SetMediaUploadStatus
   * @param {string} missionId - The mission ID
   * @return {array} - Array of mission medias data
   */
  async setMediaUploadStatus(mediaId, mediaFileId, payload) {
    const requestURI = `${this.url}${mediaId}/files/${mediaFileId}/upload`;
    try {
        const { status, data } = await this.API.put(requestURI, payload);
        return Promise.resolve({ status, data: data.data, meta: data.meta });
    } catch ({ response, code }) {
        const res = {
          data: response ? response.data : null,
          status: response ? response.status : null,
        };
        if (code === 'ECONNABORTED') {
          res.data = { message: 'Timeout Error on media validation' };
          res.status = 408;
        }
        return Promise.reject(res);
    }
  }

  /**
   * Send the Upload ID and launch the extraction
   * @param missionId
   * @param payload
   * @returns {Promise<{data, meta, status: *}>}
   */
  async setMediaUploadExtractStatus(missionId, payload) {
    const requestURI = `${this.missionUrl}${missionId}/media/extract`;
    try {
      const { status, data } = await this.API.post(requestURI, payload);
      return Promise.resolve({ status, data: data.data, meta: data.meta });
    } catch ({ response, code }) {
      const res = {
        data: response ? response.data : null,
        status: response ? response.status : null,
      };
      if (code === 'ECONNABORTED') {
        res.data = { message: 'Timeout Error on media validation' };
        res.status = 408;
      }
      return Promise.reject(res);
    }
  }

  /**
   * deleteMediaFile
   * @param {string} mediaFileId - The mediaFile ID
   * @return {Promise} -Axios.delete
   */
   async deleteMediaFile(mediaFileId) {
    const requestURI = `${this.url}${mediaFileId}`;
    return this.API.delete(requestURI);
  }

  /**
   * Fetch a single Mission Media
   * @param {string} missionId - The mission ID
   * @param {string} mediaId - The media ID
   */
  async fetchMedia(missionId, mediaId) {
    // Assemble request params
    const params = [
      `include=${this.includesMedias.join(',')}`,
      'withFilename=1',
    ];
    try {
      const response = await this.API
        .get(`${this.missionUrl}${missionId}/media/${mediaId}?p=thumb&${params.join('&')}`);
      return response.data;
    } catch {
      return null;
    }
  }

  /**
   * Fetch a single Mission Media File image URL from the API
   * @param mediaId
   * @param format
   * @param filenameFormat
   * @returns {Promise<{imageURL, mediaId}>}
   */
  async fetchMediaImageURL(mediaId, format = null, filenameFormat = null) {
    const params = [];
    if (format) {
      params.push(`p=${format}`);
    }
    if (filenameFormat) {
      params.push(`filename=${filenameFormat}`);
    }
    const requestURI = `${this.url}${mediaId}/download?${params.join('&')}`;
    try {
      const response = await this.API.get(requestURI);
      return Promise.resolve({
        mediaId,
        imageURL: response.data,
      });
    } catch (error) {
      return Promise.reject(error.response);
    }
  }

  /**
   * Create a media for a mission
   * @param offerItem
   * @param missionId
   * @returns {Promise<unknown>}
   */
  async createMissionMedia(offerItem, missionId) {
    const requestURI = `${this.missionUrl}${missionId}/media`;
    const payload = {
      data: {
        type: 'mission_media',
        relationships: {
          offer_item: {
            id: offerItem,
            type: 'offer_item',
          },
        },
      },
    };
    try {
      const response = await this.API.post(requestURI, payload);
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  }
}

const MissionMediasAPI = new _MissionMediasAPI();
export default MissionMediasAPI;
